import React from 'react';
import styled from 'styled-components';

import colors from 'utils/colors';

import { useSidenavContext } from '../context';

export type ComponentProps = {
  label?: string;
};

const Wrapper = styled.button<ComponentProps>`
  border: none;
  padding: 0 0 0 18px;
  background: 0 0;
  outline: 0;
  cursor: pointer;
  width: 60px;
  height: 60px;

  span:first-child {
    transform-origin: 0% 0%;
  }

  span:nth-last-child(2) {
    transform-origin: 0% 100%;
  }

  :focus,
  :hover {
    span {
      background: ${colors.orange};
    }
  }
`;

interface LineProps {
  width?: number;
}

const Line = styled.span<LineProps>`
  display: block;
  width: ${props => props.width || '24'}px;
  height: 4px;
  margin-bottom: 5px;
  position: relative;
  background-color: ${colors.darkGrey};
  transform-origin: 4px 0px;
  transition: background-color 150ms, -webkit-transform 0.4s;
  transition: transform 0.4s, background-color 150ms;
  transition: transform 0.4s, background-color 150ms, -webkit-transform 0.4s;
`;

const Hamburger: React.FC<ComponentProps> = ({ label = 'Toggle navigation' }) => {
  const { setIsOpen } = useSidenavContext();
  return (
    <Wrapper aria-label={label} aria-expanded='false' title={label} onClick={() => setIsOpen(true)}>
      <Line />
      <Line width={18} />
      <Line />
    </Wrapper>
  );
};

export default Hamburger;
